import { Column } from 'primereact/column'
import { DataTable } from 'primereact/datatable'
import { TabPanel, TabView } from 'primereact/tabview'
import React, { useEffect } from 'react'
import { connect } from 'react-redux'
import { CustomModal, InputText } from '../../../../../components'
import { hideLoadingBox, showMessageBox } from '../../../../../store/actions/system.actions'
import { LOAD_MESSAGE } from '../PendenciasTransportadoraHook'
import useModalPendenciasTransportadora from './ModalPendenciasTransportadoraHook'

function ModalPendenciasTransportadora({ dispatch, modal, onResponse }) {
  const { state, localDispatch } = useModalPendenciasTransportadora()

  useEffect(() => {
    if (modal.show) localDispatch.onInit(modal.data)
  }, [modal.show])

  useEffect(() => {
    switch (state.loadingMessage) {
      case LOAD_MESSAGE.NONE:
        dispatch(hideLoadingBox())
        break

      default:
        break
    }
  }, [state.loadingMessage])

  useEffect(() => {
    if (state.errorMessage) {
      dispatch(showMessageBox(null, state.errorMessage))
      localDispatch.resetState()
    }
  }, [state.errorMessage])

  return (
    <CustomModal
      isVisible={modal.show}
      header={'Extrato de Pendencias'}
      width={800}
      onClose={() => onResponse('close')}
    >
      <div className="p-grid">
        <div className="p-col-4">
          <InputText
            label="Operador Logístico:"
            marginTop={10}
            value={state.pendencia.tp_name}
            disabled={true}
            onChange={() => {}}
          />
        </div>
        <div className="p-col-4">
          <InputText
            label="Nome da Transportadora:"
            marginTop={10}
            value={state.pendencia.nome}
            disabled={true}
            onChange={() => {}}
          />
        </div>
        <div className="p-col-4">
          <InputText
            label="CNPJ:"
            marginTop={10}
            value={state.pendencia.cnpj}
            disabled={true}
            onChange={() => {}}
          />
        </div>
        <div className="p-col-12">
          <TabView
            activeIndex={state.activeIndex}
            onTabChange={e => localDispatch.onTabChange(e.index)}
          >
            <TabPanel header="Por Movimentação">
              <DataTable
                value={state.pendencia.porMovimentacao}
                paginator={true}
                rows={10}
                globalFilter={state.globalFilter}
                emptyMessage={'Sem pendencias cadastradas'}
                style={state.pendencia.porMovimentacao.length === 0 ? { textAlign: 'center' } : {}}
              >
                <Column field="movimentacao_id" header="Codigo Movimentação" />
                <Column field="data_movimentacao" header="Data" />
                <Column field="patrimonio_name" header="Patrimonio" />
                <Column field="saldo" header="Qte" />
              </DataTable>
            </TabPanel>
            <TabPanel header="Consolidadas">
              <DataTable
                value={state.pendencia.consolidado}
                paginator={true}
                rows={10}
                globalFilter={state.globalFilter}
                emptyMessage={'Sem pendencias cadastradas'}
                style={state.pendencia.consolidado.length === 0 ? { textAlign: 'center' } : {}}
              >
                <Column field="patrimonio_name" header="Patrimonio" />
                <Column field="saldo" header="Qte" />
              </DataTable>
            </TabPanel>
          </TabView>
        </div>
      </div>
    </CustomModal>
  )
}

const mapStateToProps = ({ system: { selectedTp } }) => ({ selectedTp })

export default connect(mapStateToProps)(ModalPendenciasTransportadora)
